'use strict'

class PaymentService {
  constructor ($http, API) {
    this.$http = $http
    this.API = API + '/api/payment'
  }

  generateCreditCardToken (card) {
    return this.$http({
      method: 'POST',
      url: this.API + '/credit-card/token',
      data: card
    })
  }

  generatePresentialInvoice (invoice, certificate) {
    return this.$http({
      method: 'POST',
      url: this.API + '/presential-purchase',
      data: {
        invoice,
        certificate
      }
    })
  }

  generateVideoconferenceInvoice (invoice, certificate) {
    return this.$http({
      method: 'POST',
      url: this.API + '/online-purchase',
      data: {
        invoice,
        certificate
      }
    })
  }
}

angular.module('app').service('paymentService', PaymentService)



//////////////////
// WEBPACK FOOTER
// ./services/payment.service.js
// module id = 103
// module chunks = 0